<template lang="html">
  <v-autocomplete
    class="autocomplete search-input"
    prepend-inner-icon="mdi-magnify"
    color="primary"
    item-text="trip.trip_id"
    :items="allQuotes"
    :filter="searchFilter">
    <template
      #item=" { item } ">
      <template
        v-if="typeof item !== 'object'">
        <v-list-tile-content>
          No Data..
        </v-list-tile-content>
      </template>
      <template v-else>
        <router-link
          :to="{ name: 'Edit Trip', params: { id: item.id } }">
          <v-list-tile-content>
            <v-list-tile-title
              class="title trip-id"
              v-html="item.trip.trip_id"/>
            <v-list-tile-sub-title
              class="subtitle">
              <span class="organization">
                Organization: {{ item.trip.trip_planner.organization }}
              </span>
              <span
                class="trip-planner">
                Trip Planner: {{ item.trip.trip_planner.name }}
              </span>
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </router-link>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({}),
  computed: {
    allQuotes () {
      return this.last(0)
    },
    ...mapGetters('quotes', [ 'last' ])
  },
  methods: {
    searchFilter (item, queryText) {
      const tripId = item.trip.trip_id.toLowerCase()
      const organization = 'Test Org' // item.trip.trip_planner.organization.toLowerCase()
      const plannerName = item.trip.trip_planner.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return this.tripFilter(tripId, searchText) ||
        this.orgFilter(organization, searchText) ||
        this.plannerFilter(plannerName, searchText)
    },
    tripFilter: (tripId, searchText) => tripId.indexOf(searchText) > -1,
    orgFilter: (org, searchText) => org.indexOf(searchText) > - 1,
    plannerFilter: (planner, searchText) => planner.indexOf(searchText) > -1

  },
}
</script>

<style lang="css" scoped>
</style>
